<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.order-cancellantion')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <search-buttons @search="onSearch" :statusUseFlag="false" :setOption="searchOptions"/>

          <template v-if="isLoad">
            <b-row class="mb-2">
              <b-colxx xxs="12">
                <b-button variant="primary default" @click="allConfirm">일괄 승인</b-button>
              </b-colxx>
            </b-row>
            <b-row>
              <b-colxx xxs="12">
                <b-table
                  head-variant="light"
                  ref="general-table"
                  class="vuetable"
                  id="table-transition-example"
                  :items="items"
                  align="center"
                  :fields="fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                  primary-key="bookingId"
                  responsive
                  show-empty>

                  <template v-slot:head(selected)="row">
                    <b-form-checkbox v-model="chkeckAll"></b-form-checkbox>
                  </template>

                  <template v-slot:cell(selected)="row">
                    <b-form-checkbox v-model="row.item.selected"></b-form-checkbox>
                  </template>

                  <template v-slot:cell(order_no)="row">
                    <router-link :to="`order-detail/${row.item.order_no}`" class="cls_click">{{row.item.order_no}}
                    </router-link>
                  </template>

                  <template v-slot:cell(pay_method)="row">
                    <b-button v-if="row.item.pay_method == 'Bank'"
                              variant="outline-dark default" size="sm"
                              @click="refundBank(row.item)">
                      {{row.item.pay_method}}
                    </b-button>
                    <span v-else>
                        {{row.item.pay_method}}
                      </span>
                  </template>

                  <template v-slot:cell(refund_date)="row">
                    <b-button-group vertical>
                      <b-button class="mb-2" variant="primary default" @click="confirmRefund(row.item)">승인</b-button>
                      <b-button variant="warning default" @click="refundMemoOpen(row.item)">불가</b-button>
                    </b-button-group>
                  </template>

                  <template v-slot:empty="row">
                    <h3 style="text-align: center">해당 주문 내역이 없습니다.</h3>
                  </template>

                </b-table>
                <b-pagination v-if="lastPage > 1"
                              size="sm"
                              align="center"
                              :total-rows="total"
                              :per-page="perPage"
                              v-model="currentPage"
                >
                  <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                  </template>
                  <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                  </template>
                  <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                  </template>
                  <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                  </template>
                </b-pagination>
              </b-colxx>
            </b-row>
          </template>
          <template v-else>
            <div class="loading"></div>
          </template>

          <refund_reason ref="Modal_refund_reason" :data="selected_memo" @confirm="memoSave" title="발급불가 사유안내"/>
          <refund_bank ref="Modal_refund_bank" @confirm="refundBankSave"/>

        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";

  import api from '../../constants/api'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import SearchButtons from "./components/SearchButtons";
  import '../../assets/css/custom/common.css'
  import {alignTableCenter} from "../../utils";
  import ModalMemo from "./components/ModalMemo";
  import ModalRefundBank from "./components/ModalRefundBank";

  export default {
    components: {
      'v-select': vSelect,
      'search-buttons': SearchButtons,
      'refund_reason': ModalMemo,
      'refund_bank': ModalRefundBank
    },
    data() {
      return {
        isLoad: false,
        chkeckAll: false,
        currentPage: 1,
        lastPage: 0,
        total: 0,
        perPage: 30,
        selected_order_no: null,
        selected_memo: null,
        fields: [
          {key: 'selected', label: '', ...alignTableCenter},
          {key: 'order_no', label: '주문번호', ...alignTableCenter},
          {key: 'b2b_order_no', label: 'B2B 주문번호', ...alignTableCenter},
          {key: 'goods_name', label: '상품명', ...alignTableCenter},
          {key: 'buyer', label: '구매자', ...alignTableCenter},
          {key: 'buy_count', label: '구매수', ...alignTableCenter},
          {key: 'cancel_count', label: '취소수', ...alignTableCenter},
          {key: 'cancel_type', label: '취소구분', ...alignTableCenter},
          {key: 'pay_method', label: '결제방법', ...alignTableCenter},
          {key: 'order_path', label: '주문경로', ...alignTableCenter},
          {key: 'buy_date', label: '주문일', ...alignTableCenter},
          {key: 'request_date', label: '신청일', ...alignTableCenter},
          {key: 'refund_date', label: '환불일', ...alignTableCenter},
        ],
        searchOptions: [
          {label: '주문번호', value: 'order_no'},
          {label: '상품명', value: 'goods_name'},
          {label: '구매자', value: 'buyer'},
          {label: 'B2B주문번호', value: 'b2b_order_no'},
          {label: '주문경로', value: 'order_path'},
        ],
        items: [],
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
      this.searchData()
    },
    methods: {
      searchData() {
        this.isLoad = false
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order)
        const params = {}

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {

          } else {
            throw 400
          }
        }).catch(err => {

        })

        this.items = [
          {
            selected: '',
            order_no: '20200105195911',
            B2B: '12313134',
            goods_name: '롯데호텔 서울 라세느 뷔페',
            buyer: '구매자',
            buy_count: 17,
            cancel_count: 0,
            cancel_type: '전체취소',
            pay_method: 'Card',
            order_path: '외부채널',
            buy_date: this.$moment(new Date()).format('YYYY-MM-DD'),
            request_date: this.$moment(new Date()).format('YYYY-MM-DD'),
            refund_date: this.$moment(new Date()).format('YYYY-MM-DD'),
            refund_reason: '취소사유' ,
            bankInputed : false
          }, {
            selected: '',
            order_no: '20200105195907',
            B2B: '12313134',
            goods_name: '롯데호텔 서울 라세느 뷔페',
            buyer: '구매자',
            buy_count: 17,
            cancel_count: 0,
            cancel_type: '전체취소',
            pay_method: 'Bank',
            order_path: '온라인',
            buy_date: this.$moment(new Date()).format('YYYY-MM-DD'),
            request_date: this.$moment(new Date()).format('YYYY-MM-DD'),
            refund_date: this.$moment(new Date()).format('YYYY-MM-DD'),
            refund_reason: '취소사유',
            bankInputed : false
          },
        ]

        this.isLoad = true
      },

      onSearch(searchObj) {
        this.searchData()
      },
      confirmRefund(item) { //환불승인
        if (item.pay_method === 'Bank' && item.bankInputed !== true) {
          alert('결제방식이 Bank 일 경우 환불걔좌 정보를 넣어야 합니다.')
          return false
        } else {
          //환불처리
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order)
          const params = {}

          this.$http.post(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if (res.data.code === "OK") {

            } else {
              throw 400
            }
          }).catch(err => {

          })
        }
      },
      denyRefund(){ //환불 거절
        alert('거절')
      },
      //환불계좌 정보 저장
      refundBankSave(bankInfo) {
        let index = this.items.findIndex(item => item.order_no === this.selected_order_no)
        this.items[index].bankInputed = true

      },
      refundBank(item) {
        this.selected_order_no = item.order_no
        this.$refs.Modal_refund_bank.open()
      },
      refundMemoOpen(item) {
        this.selected_order_no = item.order_no
        this.selected_memo = item.refund_reason
        this.$refs.Modal_refund_reason.open()
      },
      memoSave(memo) { //메모저장
        alert("문자발송 되야 합니다.\n\n[테이블엔조이]\n죄송합니다.담당자에 의하여, \n요청하환불신청이거절되었습니다." +
          "\n사유는 아래와 같습니다.\n" + memo + "\n재신청하기 : 취소신청 url 삽입")
      },

      allConfirm() {
        let selected = false
        let count = 0
        let bankTypeCount = 0
        let bankInputed = false
        this.items.forEach((v) => {
          if (v.selected) {
            selected = true
            count++

            if (v.pay_method === "Bank") { //입금방식이면 환불 계좌를 받아야함.
              bankTypeCount++
              if (v.bankInputed) {
                bankInputed = true
              }
            }
          }
        })

        if (!selected) {
          alert('일괄 승인할 대상을 선택해주세요.')
          return false
        } else if (bankTypeCount > 0 && bankInputed === false) {
          alert('결제방법이 Bank인 대상은 환불계좌 정보를 입력해줘야만 환불이 가능합니다.')
          return false
        } else {
          if (confirm(count + '건을 일괄 승인하시겠습니까? ')) {

          }
        }
      }
    }
    , watch: {
      chkeckAll(chk) {
        this.items.forEach((v) => {
          v.selected = chk
        })
      }
    }
  }
</script>
